import React, { useState } from "react";
import { Button, FormFieldSet, PageTitle, TableAdv } from "../../../components";
import { formatNumber, mapTableRows } from "../../../utils";
import dayjs from "dayjs";
import { generateDateWiseData } from "../../../dummydata/dataAging";
const Aging = () => {
  const [showDetails, setShowDetails] = useState(false);
  const [showDetailsId, setShowDetailsId] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState({
    from: dayjs().toDate(),
    to: dayjs().toDate(),
  });

  const onDateRangeChange = (date) => {
    setSelectedDateRange(date);
  };

  const onClickShowDetails = (id) => {
    setShowDetailsId(id);
    setShowDetails(!showDetails);
  };
  const closeShowDetails = () => {
    setShowDetailsId(false);
    setShowDetails(false);
  };

  const toNumber = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    if (typeof value === "number") return Number.isFinite(value) ? value : 0;
    if (typeof value === "string") {
      const parsed = Number(value.replace(/,/g, ""));
      return Number.isFinite(parsed) ? parsed : 0;
    }
    const coerced = Number(value);
    return Number.isFinite(coerced) ? coerced : 0;
  };

  //   const rows = Array.from({ length: 10 }, (_, i) => ({
  //     id: i + 100,
  //     client: `Company ${i + 1}`,
  //     current: Math.floor(Math.random() * 12600),
  //     "1to30": Math.floor(Math.random() * 12600),
  //     "31to60": Math.floor(Math.random() * 12600),
  //     "61to90": Math.floor(Math.random() * 12600),
  //     "91to120": Math.floor(Math.random() * 12600),
  //     action: ["Funded", "Non Funded"][Math.floor(Math.random() * 2)],
  //   }));

  //   const filteredData = [];
  const fromDay = selectedDateRange?.from
    ? dayjs(selectedDateRange.from).startOf("day")
    : null;
  const toDay = selectedDateRange?.to
    ? dayjs(selectedDateRange.to).endOf("day")
    : null;

  const normalizedFrom =
    fromDay && toDay && fromDay.isAfter(toDay) ? toDay : fromDay;
  const normalizedTo =
    fromDay && toDay && fromDay.isAfter(toDay) ? fromDay : toDay;

  const rawDateWiseData = generateDateWiseData({
    startDate: dayjs().subtract(6, "month").format("YYYY-MM-DD"),
    endDate: dayjs().format("YYYY-MM-DD"),
    companyCount: 10,
  });

  const filteredByDate = rawDateWiseData.filter(({ date }) => {
    const d = dayjs(date, "YYYY-MM-DD");
    if (normalizedFrom && d.isBefore(normalizedFrom, "day")) return false;
    if (normalizedTo && d.isAfter(normalizedTo, "day")) return false;
    return true;
  });

  const aggregatedByCompany = new Map();
  filteredByDate.forEach(({ company }) => {
    company.forEach((row) => {
      const existing = aggregatedByCompany.get(row.id) ?? {
        id: row.id,
        client: row.client,
        current: 0,
        "1to30": 0,
        "31to60": 0,
        "61to90": 0,
        "91to120": 0,
        action: row.action,
      };

      existing.current += toNumber(row.current);
      existing["1to30"] += toNumber(row["1to30"]);
      existing["31to60"] += toNumber(row["31to60"]);
      existing["61to90"] += toNumber(row["61to90"]);
      existing["91to120"] += toNumber(row["91to120"]);
      existing.action =
        existing.action === "Funded" || row.action === "Funded"
          ? "Funded"
          : "Non Funded";

      aggregatedByCompany.set(row.id, existing);
    });
  });

  const filteredData = Array.from(aggregatedByCompany.values());
  const rows = filteredData;
  const columns = [
    {
      key: "client",
      labelKey: "client",
      label: "Company Name",
      render: (row) => {
        return (
          <div
            className="text-left flex gap-1 items-center text-nowrap"
            onClick={() => onClickShowDetails(row.id)}
          >
            {row.client ? row.client : "-"}
            <span
              className={`text-[10px] p-1 px-2 rounded-full ${row.action === "Funded" ? "bg-info-100/50 text-info-800" : "bg-danger-100/50 text-danger-800"}`}
            >
              {row.action}
            </span>
          </div>
        );
      },
    },
    {
      key: "current",
      labelKey: "current",
      label: "Current",
      render: (row) => {
        return <div>{row.current ? formatNumber(row.current) : "-"}</div>;
      },
      total: true,
    },
    {
      key: "1to30",
      labelKey: "1to30",
      label: "1-30 Days",
      render: (row) => {
        return <div>{row["1to30"] ? formatNumber(row["1to30"]) : "-"}</div>;
      },
      total: true,
    },
    {
      key: "31to60",
      labelKey: "31to60",
      label: "31-60 Days",
      render: (row) => {
        return <div>{row["31to60"] ? formatNumber(row["31to60"]) : "-"}</div>;
      },
      total: true,
    },
    {
      key: "61to90",
      labelKey: "61to90",
      label: "61-90 Days",
      render: (row) => {
        return <div>{row["61to90"] ? formatNumber(row["61to90"]) : "-"}</div>;
      },
      total: true,
    },
    {
      key: "91to120",
      labelKey: "91to120",
      label: "91-120 Days",
      render: (row) => {
        return <div>{row["91to120"] ? formatNumber(row["91to120"]) : "-"}</div>;
      },
      total: true,
    },
    {
      key: "total",
      labelKey: "total",
      label: "Total",
      render: (row) => {
        return (
          <div>
            {formatNumber(
              toNumber(row.current) +
                toNumber(row["1to30"]) +
                toNumber(row["31to60"]) +
                toNumber(row["61to90"]) +
                toNumber(row["91to120"]),
            )}
          </div>
        );
      },
      valueGetter: (row) =>
        toNumber(row.current) +
        toNumber(row["1to30"]) +
        toNumber(row["31to60"]) +
        toNumber(row["61to90"]) +
        toNumber(row["91to120"]),
      total: true,
    },

    // {
    //   key: "action",
    //   label: "Action",
    //   render: (row) => {
    //     return (
    //       <div className="flex gap-2">
    //         <Button
    //           title={row.action}
    //           size="sm"
    //           color={row.action === "Funded" ? "success" : "danger"}
    //           onClick={() => onClickShowDetails(row.id)}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];
  const mappedRows = mapTableRows(rows, columns);

  const rowsShowDetails = filteredData.filter(
    (row) => row.id === showDetailsId,
  );
  const columnsShowDetails = [
    {
      key: "client",
      labelKey: "client",
      label: "Date",
    },
    {
      key: "client",
      labelKey: "client",
      label: "Transaction Type",
    },
    {
      key: "client",
      labelKey: "client",
      label: "Invoice Number",
    },
    {
      key: "client",
      labelKey: "client",
      label: "Client Full Name",
    },
    {
      key: "client",
      labelKey: "client",
      label: "Location Full Name",
    },
    {
      key: "client",
      labelKey: "client",
      label: "Due Date",
    },
    {
      key: "client",
      labelKey: "client",
      label: "Amount",
    },
    {
      key: "client",
      labelKey: "client",
      label: "Opening Balance",
    },
  ];

  const mappedRowsShowDetails = mapTableRows(
    rowsShowDetails,
    columnsShowDetails,
  );

  return (
    <div className="flex-1 flex flex-col p-2 overflow-hidden">
      <div className="flex gap-1 items-baseline">
        {showDetails && (
          <Button
            variant="text"
            color="dark"
            size="sm"
            type="icon"
            icon={"west"}
            onClick={closeShowDetails}
          />
        )}
        <PageTitle title="A/R Aging Summary Report" />
        <span className="text-xs text-gray-300">(As of March 18,2026)</span>
      </div>

      <div className="flex-1 flex flex-col  overflow-hidden">
        {showDetails ? (
          <div className="flex-1 flex flex-col overflow-hidden my-3">
            <TableAdv
              columns={columnsShowDetails}
              rows={mappedRowsShowDetails}
              hideToolBar={true}
            />
          </div>
        ) : (
          <div className="flex-1 flex flex-col overflow-hidden">
            <div>
              <div className="flex gap-1 items-baseline my-3">
                <FormFieldSet
                  title="Select date"
                  type="datepickerRange"
                  placeholder="Select date"
                  value={selectedDateRange}
                  onChange={onDateRangeChange}
                />
              </div>
            </div>
            <TableAdv columns={columns} rows={mappedRows} hideToolBar={true} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Aging;
